import {ReportFilters} from "../reports/common/models/ReportFilters"
import moment from "moment"
import {reportsStore} from "../reports/common/stores/ReportStore"
import {ReportGraphFilters} from "../reports/common/models/ReportGraphFilters"
import {groupMasterStore} from "../common/group/GroupMasterStore"
import {GroupInfo} from "../common/group/models/GroupInfo"
import {PrintOptions} from "../reports/common/components/PrintViewContainer"
import {ReportSummaryGraphs} from "../reports/district-school/models/ReportSummaryGraphs"
import {TableDataResults} from "../reports/class/models/TableDataResults"
import {SkillColumnData} from "./components/testTakerSortableTable/Columns"

export interface ReportProps {
    groupInfo?: GroupInfo
    printOptions?: PrintOptions
    filters: ReportFilters
    query?: ReportGraphFilters
    graphData?: ReportSummaryGraphs
    tableData?: TableDataResults
    isPlace?: boolean
    skillColumns: SkillColumnData[]
    isMultiLanguage?: boolean
}

export function getStampReportSearchQuery(filters: ReportFilters): ReportGraphFilters {
    const {groupId, productId, startDate, endDate, assessmentStart, recentActivity} = filters
    const startDateStartOfDay = moment(startDate).startOf("day").valueOf()
    const endDateEndOfDay = moment(endDate).endOf("day").valueOf()
    reportsStore.searchFilters = {groupId, productId, assessmentStart, recentActivity, startDate, endDate}

    return {
        groupId,
        productId,
        start: startDateStartOfDay,
        end: endDateEndOfDay,
        searchByStartTimes: assessmentStart,
        searchByMostRecentActivityTimes: recentActivity,
        loadAverages: true,
        omitEmptySkillsNotInAssessment: true,
    }
}

export function fetchStampFamilyData(filters: ReportFilters) {
    const query: ReportGraphFilters = getStampReportSearchQuery(filters)

    reportsStore.findReportGraphs(query)
    reportsStore.findReportTableData(query)
    reportsStore.findDownloadedReportTableData(query)
    reportsStore.resetDownloads()
    groupMasterStore.groupInfo = undefined
    groupMasterStore.findGroupInfo(filters.groupId)
}

export function fetchStampSignLanguageData(filters: ReportFilters) {
    const query: ReportGraphFilters = getStampReportSearchQuery(filters)

    reportsStore.findReportGraphs(query)
    reportsStore.findReportTableData(query)
    reportsStore.findDownloadedReportTableData(query)
    reportsStore.resetDownloads()
    groupMasterStore.groupInfo = undefined
    groupMasterStore.findGroupInfo(filters.groupId)
}
